import { ReactNode } from 'react';

import './styles.scss';

type VolatilitySufaceMarkingSidebarSelectProps = {
  children?: ReactNode;
  label?: string;
};

export const VolatilitySufaceMarkingSidebarSelect = ({
  children,
  label,
}: VolatilitySufaceMarkingSidebarSelectProps) => {
  return (
    <div className="volatility-suface-marking-sidebar-select-area">
      {label && (
        <span className="volatility-suface-marking-sidebar-content-select-label">{label}</span>
      )}
      {children}
    </div>
  );
};
